<div class="wrapper">
  <div class="announcements-container">
    <div class="announcements-header">
      <div class="page-title">Announcements</div>
      @if (!loading && emails.length > 0) {
        <div class="page-size">
          <app-page-size
            [pageSize]="pageSize"
            [selectId]="'announcements'"
            (pageSizeChanged)="onPageSizeChange($event)"
          ></app-page-size>
        </div>
      }
    </div>

    @if (!loading) {
      <div class="action-row">
        <button
          class="add-announcement-btn"
          (click)="onComposeClick()"
          aria-label="Compose new announcement"
        >
          <app-svg-icon
            [iconName]="'add.svg'"
            [height]="'16px'"
            [width]="'16px'"
            [style.fill]="'#fff'"
          ></app-svg-icon>
          <span>New Announcement</span>
        </button>
      </div>
    }

    <app-table
      [columns]="tableColumns"
      [data]="emails"
      [loading]="loading"
      [noResultsMessage]="'No announcements found.'"
      [skeletonRows]="5"
    >
      <ng-template let-email>
        <tr>
          <td>
            <div class="recipients-cell" [title]="getRecipientsEmails(email)">
              {{ getRecipientsEmails(email) }}
            </div>
          </td>
          <td>
            <div class="type-tags-cell">
              @if (email.email) {
                <span class="announcement-type-tag type-email"> Email </span>
              }
              @if (email.notification) {
                <span class="announcement-type-tag type-notification">
                  Notification
                </span>
              }
            </div>
          </td>
          <td>
            <div class="subject-cell" [title]="email.subject">
              {{ email.subject }}
            </div>
          </td>
          <td>
            <div class="message-cell" [innerHTML]="email.message"></div>
          </td>
          <td style="color: #6b7280; font-size: 0.875rem">
            {{ email.created_on_utc | date: "MMM d, y, h:mm a" }}
          </td>
          <td>
            <div class="action-cell">
              <a
                href="javascript:void(0)"
                (click)="selectEmail(email)"
                class="view-link"
              >
                View
              </a>
            </div>
          </td>
        </tr>
      </ng-template>
    </app-table>

    @if (emails.length > 0) {
      <app-pagination
        [currentPage]="currentPage"
        [pageSize]="pageSize"
        [totalItems]="totalEmails"
        (pageChanged)="onPageChange($event)"
      ></app-pagination>
    }
  </div>

  @if (isComposing) {
    <app-announcement-create
      (sent)="onAnnouncementSent()"
      (cancelled)="onAnnouncementCancelled()"
    ></app-announcement-create>
  }

  @if (selectedEmail) {
    <app-secondary-popup
      [title]="'Announcement Details'"
      [isActionButtonsAvailable]="false"
      (popupClosed)="onCloseDetailsPopup()"
    >
      <app-announcement-details
        [announcement]="selectedEmail"
        (popupClosed)="onCloseDetailsPopup()"
      ></app-announcement-details>
    </app-secondary-popup>
  }
</div>
